const getters = {
  GET_BADGE_COUNT (state) {
    return state.badgeCount
  },
  GET_ID (state) {
    return state.userData.id
  },
  GET_NAME (state) {
    return state.userData.userName
  },
  GET_MAIL (state) {
    return state.userData.mail
  },
  GET_USER_DATA (state) {
    return state.userData
  },
  getFailIdentity: state => state.failIdentity,
  getVersion: state => state.version,
  getIdentity (state) {
    return state.encData
  },
  getPrivacy (state) {
    return state.view.authorizeChecked.privacyCheck
  },
  getTerms (state) {
    return state.view.authorizeChecked.termsCheck
  },
  getTemporaryPrivacy (state) {
    return state.view.authorizeChecked.temporaryPrivacyCheck
  },
  getTemporaryTerms (state) {
    return state.view.authorizeChecked.temporaryTermsCheck
  },
  getTelDataCarry (state) {
    return state.telDataCarry
  },
  getComing (state) {
    return state.coming
  },
  getComingTell (state) {
    return state.comingTell
  },
  getComingList (state) {
    return state.coming.list
  },
  getDoctorList (state) {
    return state.doctorInfo
  },
  getSchedule (state) {
    return state.doctorSchedule
  },
  getVisitList (state) {
    return state.visit.list
  },
  getSurgeryList (state) {
    return state.surgery.surgeryList
  },
  getSurgeryDate (state) {
    return state.surgeryDate
  },
  getKakaoUrl (state) {
    return state.surgery.kakaoUrl
  },
  getBanner (state) {
    return state.banner
  },
  getBannerDetail (state) {
    return state.bannerDetail
  },
  GET_CALENDAR_LIST (state) {
    return state.calendarList.list
  },
  GET_RESERVATION_LIST (state) {
    return state.reservationList
  },
  GET_TOKEN_PERIOD (state) {
    return state.userData.tokenPeriod
  },
  GET_TOKEN (state) {
    return state.userData.token
  },
  GET_USERNAME (state) {
    return state.userData.userName
  },
  IS_LOGIN (state) {
    return state.userData.userName !== ''
  },
  IS_AUTH (state) {
    return state.userData.token !== ''
  },
  GET_CHECKED_PW (state) {
    return state.userData.checkedPw
  },
  GET_TEMPORARY_DATA (state) {
    return state.temporaryData
  },
  GET_USERINFO_LIST (state) {
    return state.userInfo.list
  },
  GET_CAUSE_ACTION (state) {
    return state.checkPopupHeader
  },
  GET_POPUP_HEADER_MAIN (state) {
    return state.checkPopupHeaderMain
  },
  GET_PUSH_RESULT (state) {
    return state.pushList.result
  },
  GET_PUSH_LIST (state) {
    return state.pushList.list
  },
  GET_PUSH_COUNT (state) {
    return state.pushList.count
  },
  GET_PUSH_CHECK (state) {
    return state.pushList.check
  },
  GET_TARGET_DATE (state) {
    return state.calendarList.targetDate
  },
  GET_DOCTOR_CODE (state) {
    return state.doctorCode
  },
  GET_DEVICE_PUSHKEY (state) {
    return state.device.pushKey
  },
  GET_DEVICE_DEVICEID (state) {
    return state.device.deviceId
  },
  GET_DEVICE_APPVERSION (state) {
    return state.device.appVersion
  },
  GET_DEVICE_DEVICE (state) {
    return state.device.device
  },
  GET_RESERVATION_CHECK (state) {
    return state.reservationInfo
  },
  GET_RESERVATION_MESSAGE (state) {
    return state.view.reservationDone
  },
  GET_RESERVATION_UPDATE_FAIL_MESSAGE (state) {
    return state.view.reservationUpdateQuit
  },
  GET_RESERVATION_UPDATE_DONE_mMESSAGE (state) {
    return state.view.reservationUpdateDone
  },
  GET_SCARDETAIL_INIT_MESSAGE (state) {
    return state.view.scarUploadEscape
  },
  GET_RESERVATION_SEARCH (state) {
    return state.reservationListInfo
  },
  GET_RESERVATION_ITEM_INFO (state) {
    return state.reservationItemInfo
  },
  GET_RESERVATION_INIT_MESSAGE (state) {
    return state.view.reservationInit
  },
  GET_REDIRECT_MAIN_MESSAGE (state) {
    return state.view.redirectMainMessage
  },
  GET_PRE_REASERVATION (state) {
    return state.preReservation
  },
  GET_DELETEDONE_MESSAGE (state) {
    return state.view.deleteReservationDone
  },
  GET_REBOOKINGSET (state) {
    return state.reBookingSet
  },
  GET_CHECKAGREEMENT (state) {
    return state.view.guestCheckAgreement
  },
  GET_SCARINFO_LIST (state) {
    return state.scarInfoList
  },
  GET_SCAR_INFOCODE (state) {
    return state.scarInfoCode
  },
  GET_SCAR_INFO (state) {
    return state.scarInfoData
  },
  GET_SURGERY_DONE (state) {
    return state.view.surgeryDone
  },
  GET_SURGERY_CODE (state) {
    return state.surgeryCodeSet
  },
  GET_UPLOAD_LIST (state) {
    return state.scarUploadList
  },
  GET_FETCHED_SCARIMG (state) {
    return state.scarFetchedImg
  },
  GET_UPLOAD_PRE_DATA (state) {
    return state.uploadPreData
  },
  GET_UPLOAD_MESSAGE (state) {
    return state.view.scarUploadDone
  },
  GET_PREV_URL (state) {
    return state.prevUrl
  },
  GET_REFRESH_APPHEADER (state) {
    return state.view.refreshAppHeader
  },
  GET_SIDEBAR_OPEN (state) {
    return state.view.isSideBarOpen
  },
  GET_INFO_LOGING (state) {
    return state.view.isLogin
  },
  GET_CAUSE_AUTHERROR (state) {
    return state.isCauseAuthError
  },
  GET_POPUP_OPEN (state) {
    return state.checkPopup
  },
  GET_AUTO_LOGIN_DONE (state) {
    return state.view.autoLoginDone
  },
  GET_SIDEBAR_ALARM (state) {
    return state.view.sidebarAlarm
  },
  GET_PUSH_ABLE (state) {
    return state.view.pushAble
  },
  GET_MEDICAL_MONTH_DATE (state) {
    return state.medicalMonthDate
  },
  GET_RESV_CODE (state) {
    return state.param.resvCode
  },
  GET_PASSED_LOGIC (state) {
    return state.view.logicPassed
  },
  GET_RESERVATION_RESULT (state) {
    return state.view.reservationDone
  }
}

export default getters
